<template>
    <div id="app">
        <div>
            <div class="e-card triggerCard" style="margin-top:50px">
                <!--<button class="e-card-btn">
                    <img src="../assets/icons/alert.png" style="height: 30px;width: 30px;">
                </button>-->
                <h1 class="activeTriggerHeader">  HIT TRIGGER </h1>
                <h1 class="activeTriggerHeader">  {{hit}}</h1>
                <div class="e-card-content">
                </div>
                <div class="e-card-actions e-card-vertical">
                    <button class="e-card-btn" v-on:click="toTriggerHitAlert()">Go To Hit Trigger Alerts</button>
                </div>
            </div>
        </div>
        <div>
            <div class="e-card triggerCard" style="margin-top:50px">
                <!--<button class="e-card-btn">
                    <img src="../assets/icons/alert.png" style="height: 30px;width: 30px;">
                </button>-->
                <h1 class="dueLiveTriggerHeader">  TRIGGER STATUS </h1>
                <h1 class="dueLiveTriggerHeader"> {{status}}</h1>
                <div class="e-card-content">
                </div>
                <div class="e-card-actions e-card-vertical">
                    <button class="e-card-btn" v-on:click="toStatusAlert()">Go To Due Status Trigger Alerts</button>
                </div>
            </div>
        </div>
        <div>
            <div class="e-card triggerCard" style="margin-top:50px">
                <!--<button class="e-card-btn">
                    <img src="../assets/icons/alert.png" style="height: 30px;width: 30px;">
                </button>-->
                <h1 class="expiredTriggerHeader">  DEFAULT DEADLINE</h1>
                <h1 class="expiredTriggerHeader">  {{deadline}}</h1>
                <div class="e-card-content">
                </div>
                <div class="e-card-actions e-card-vertical">
                    <button class="e-card-btn" v-on:click="toDeadlineAlert()">Go To Default Deadline Alerts</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import urls from '../common/urls';
    import apis from '../common/network';

    export default {
        data() {
            return {

                deadline: "",
                status: "",
                hit: "",
            };
        },
        methods: {
            toStatusAlert(args) {
                this.$router.push({ name: 'Trigger Status' });
            }, toTriggerHitAlert(args) {
                this.$router.push({ name: 'Hit Triggers' });
            }, toDeadlineAlert(args) {
                this.$router.push({ name: 'Default Deadlines' });
            },
            fetchData(id) {
                apis.protectedApi(`${urls.apiBaseUrl}TriggerAlert/GroupCounts`).then(it => {
                    this.deadline = it.data.deadline;
                    this.status = it.data.status;
                    this.hit = it.data.hit;

                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        alert("Error: " + message);
                    }
                );

            },
        },
        created: function () {
            this.fetchData();
        },
    }
</script>
<style>

    .triggerCard {
        margin-left: 30%;
        width: 700px;
    }

    .activeTriggerHeader {
        text-align: center;
        text-transform: uppercase;
        color: #001c55;
    }

    .dueLiveTriggerHeader {
        text-align: center;
        text-transform: uppercase;
        color: #7FB7BE;
    }

    .expiredTriggerHeader {
        text-align: center;
        text-transform: uppercase;
        color: #d9843b;
    }
</style>